import React, { useEffect, useState } from 'react';
import Popup from '../Popup';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getBoardId, getBoardViewId } from 'src/services/firebaseInit';
import * as S from './styles';

type PopupProps = {
  open: boolean;
  onCancel?: () => void;
};

async function delay(time: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, time));
}

async function exportRetrospectives(): Promise<string> {
  const exportProjectFunction = httpsCallable<unknown, string>(
    getFunctions(),
    'exportProject'
  );

  const { data } = await exportProjectFunction({
    boardId: getBoardId(),
    boardViewId: getBoardViewId(),
  });
  return data;
}

function PopupContent({ open }: PopupProps) {
  const [url, setUrl] = useState('');

  useEffect(() => {
    (async () => {
      if (!open) {
        setUrl('');
        return;
      }
      const [url] = await Promise.all([exportRetrospectives(), delay(2000)]);
      setUrl(url);
    })();
  }, [open]);

  return (
    <div>
      {url ? (
        <>
          <p>
            Export complete.{' '}
            <a target="_blank" rel="noreferrer" href={url}>
              Click here to download the file.
            </a>
          </p>
          <br />
          <p>
            Alternatively, you can copy and paste the following link on your
            browser. This link is valid for 15 minutes:
          </p>
          <S.FileLink target="_blank" rel="noreferrer" href={url}>
            {url}
          </S.FileLink>
        </>
      ) : (
        <S.SpinnerContainer>
          <S.Spinner></S.Spinner>
          <p>
            Exporting retrospectives. This operation might take up to a
            minute...
          </p>
        </S.SpinnerContainer>
      )}
    </div>
  );
}

export function ExportRetropectivesPopup({ open, onCancel }: PopupProps) {
  return (
    <Popup
      open={open}
      title={'Export Retrospectives'}
      onCancel={onCancel}
      body={<PopupContent open={open} />}
    ></Popup>
  );
}
